import { BoolFilter, FilterList, FlagFilter } from "@dash/filters";
import { Page, PageHeader } from "@dash/page";
import { Pagination } from "@dash/search";
import { QuerySkeleton } from "@dash/skeleton";

import { useClientManager } from "@megaron/react-clients";

import { AccountsTable } from "./AccountsTable";
import { useAccountsFilters } from "./useAccountsFilters";

export const AccountsHome = () => {
  const { filters, setFilter } = useAccountsFilters();

  const pageSize = 20;
  const page = filters.page ?? 0;
  const offset = page * pageSize;

  const cashRewardsClient = useClientManager("cashRewards");

  const accountsQuery = cashRewardsClient.accountsQuery().useQuery({
    limit: pageSize,
    offset,
    excludeZeroBalance: filters.excludeZeroBalance ?? false,
    sortByBalance: filters.sortByBalance,
  });

  return (
    <Page css={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "100%" }}>
      <PageHeader>Konta użytkowników</PageHeader>
      <div
        css={{
          display: "flex",
          gap: "1rem",
          marginBottom: "0.5rem",
          flexWrap: "wrap",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <FilterList>
          <FlagFilter
            isActive={filters.excludeZeroBalance === true}
            label="Wyklucz zera"
            onClick={() => setFilter("excludeZeroBalance")(!filters.excludeZeroBalance)}
            onDelete={() => setFilter("excludeZeroBalance")(false)}
          />
          <BoolFilter
            label="Sortuj po saldzie"
            value={filters.sortByBalance === "desc" ? true : filters.sortByBalance === "asc" ? false : undefined}
            onChange={(value) => setFilter("sortByBalance")(value === true ? "desc" : value === false ? "asc" : undefined)}
            trueLabel="Malejąco"
            falseLabel="Rosnąco"
          />
        </FilterList>
        <Pagination
          css={{ maxHeight: "41px", alignSelf: "flex-end" }}
          page={page}
          onPageChange={(p) => {
            setFilter("page")(p);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          pageSize={pageSize}
          itemCount={accountsQuery.data?.count ?? 0}
        />
      </div>
      <QuerySkeleton query={accountsQuery}>
        {(data) => (
          <AccountsTable
            accounts={data.items}
          />
        )}
      </QuerySkeleton>
    </Page>
  );
};
